import { useAxios } from './axiosService';

const useUserService = () => {
    const { axios } = useAxios();

    // config.quietErrors: a background re-read that shows no error of its own (see axiosService)
    const getUser = async (config = undefined) => {
        return await axios.get('/auth-consumers/me', config);
    };
    const getUserById = async id => {
        return await axios.get(`/consumers/${id}`);
    };
    const getAllUsers = async ({ offset, limit, isDeleted, globalSearch, status, roles, sortField, sortOrder }) => {
        return await axios.post('/consumers', {
            offset: (offset - 1) * limit,
            limit: limit,
            isDeleted,
            globalSearch,
            status,
            roles,
            sortField,
            sortOrder,
        });
    };

    const getUserRoles = async () => {
        return await axios.get('/consumers/user-roles');
    };

    const updateUser = async body => {
        await axios.put('/consumers/update-user', body);
    };

    const updateProfile = async body => {
        await axios.put('/consumers/update-profile', body);
    };

    const deleteUsers = async ids => {
        await axios.delete('/consumers/', {
            data: { ids },
        });
    };

    const archiveUsers = async ids => {
        await axios.patch('/consumers/archive', { ids });
    };

    const unarchiveUsers = async ids => {
        await axios.patch('/consumers/restore', { ids });
    };

    const changeLanguage = async language => {
        await axios.post(`/auth-consumers/change-language`, {
            language,
        });
    };

    // the API answers with the value it stored (re-read), which is what the switch then shows
    const updateMarketingConsent = async marketingConsent => {
        return await axios.put('/consumers/marketing-consent', { marketingConsent });
    };

    // the one-time consent prompt; the API stores only a first choice and answers the stored value
    const answerMarketingConsentPrompt = async marketingConsent => {
        return await axios.put('/consumers/marketing-consent/prompt', { marketingConsent });
    };

    const getUserLanguage = async () => {
        return await axios.get('/auth-consumers/language');
    };

    return {
        getUser,
        getUserById,
        getAllUsers,
        getUserRoles,
        updateUser,
        deleteUsers,
        archiveUsers,
        unarchiveUsers,
        updateProfile,
        changeLanguage,
        getUserLanguage,
        updateMarketingConsent,
        answerMarketingConsentPrompt,
    };
};

export { useUserService };
